import { equals, find, propEq } from "ramda";

import { isOrderAheadSlotExpired } from "helpers/date/dateHelpers";
import type {
  IOrderAheadDate,
  IOrderingOptionsState,
} from "types/reducers/ordering_options";
import type { StoreInfo } from "types/reducers/store_info";

/**
 * True when the selected "Later" order time is before the soonest allowed
 * submit time (now + fulfillment estimate upper bound).
 */
export function orderTimeExpired(
  orderingOptions: IOrderingOptionsState,
  storeInfo: StoreInfo
): boolean {
  if (equals(orderingOptions.selectedTimeFrame, "Later")) {
    const methodDetails = find(
      propEq("name", orderingOptions.selectedTransport),
      storeInfo.fulfillmentTypes
    );
    const estimateWindow = methodDetails ? methodDetails.estimate[1] : 0;

    const orderAheadDate = orderingOptions.orderAheadDate as IOrderAheadDate;
    return isOrderAheadSlotExpired(
      orderingOptions.orderAheadTime,
      orderAheadDate.selectedDate,
      estimateWindow
    );
  }

  return false;
}
